import { defineMessages } from 'react-intl-next';

export const PriorityDropdownMessages = defineMessages({
	CustomPriority: {
		id: `eoc.priority-dropdown.custom-priority`,
		defaultMessage: `Custom priority`,
		description: `The text will be displayed in the dropdown menu if the user has written a custom priority`,
	},
});
